// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import {Loading ,MessageBox ,Message} from 'element-ui';
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css';
import IScrollView from 'vue-iscroll-view'
import IScroll from 'iscroll'
import VueVideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'
import Utils from './utils'
import axios from "axios"
import Vueaxios from "vue-axios"
import dateTime from 'vue-date-time-m';
import Print from 'vue-print-nb'
/* eslint-disable no-new */
// 引入echarts
import store from './store' // 引入你的 store 配置

Vue.use(Print)
Vue.use(dateTime)
Vue.use(ElementUI)
Vue.use(VueVideoPlayer)
Vue.use(IScrollView, IScroll)
Vue.use(VueAwesomeSwiper)
Vue.use(Vueaxios , axios )
let loadingInstance='';

axios.interceptors.request.use(function (config) {
    if (config.url != '/api/index/Article' && config.url != '/api/SignUp/OrderQuery'
    && config.url != '/api/Course/Times' && config.url != '/api/SignUp/Invoice'
    && config.url != '/api/Course/Chapter'  && config.url !=  '/api/SignUp/GetPayUrl' &&  config.url !=  '/api/SignUp/OrderQuery') {
        loadingInstance = Loading.service({ fullscreen: true ,background:'rgba(0, 0, 0, 0.6)'});
    }
    // 先获取token
    const token = store.state.user.token
    // 判断是否存在token，如果存在，需要设置请求头
    if(token) {
      config.headers['token'] = token
    }
    return config;
    }, function (err) {
    return Promise.reject(err);
});
axios.interceptors.response.use(function (response) {
    //   window.scrollTo(0,0)
    if (loadingInstance) {
        loadingInstance.close()
    }
    if(response.data.code !== 200){ 
      console.log(response.data.code,'拦截器code');
      console.log(response.data,'拦截器data');
      // 检查是否是 CreateQrcode 接口（二进制响应）
      if (response.config.url.includes('/Manage/CreateQrcode')) {
          console.log('跳过二进制接口的拦截器处理');
          return response; // 直接返回，不进行错误处理
      }
       // 获取当前路由信息
        let currentRoute = router.currentRoute; // Vue Router 3
        // 或 Vue Router 4: const currentRoute = router.currentRoute.value;
        
        console.log('当前路由:', currentRoute.fullPath); // 输出完整路径
        console.log('路由名称:', currentRoute.name);      // 输出路由名称
        if(response.data.code === 401) {
            MessageBox.alert('<div class="bgIconAlert">'+response.data.msg+'</div>', '', {
                dangerouslyUseHTMLString: true,
                // confirmButtonText: '关闭',
                center: true
            }).then(()=>{
              if(currentRoute.name == 'home' || currentRoute.name == 'course' || currentRoute.name == 'training' 
                || currentRoute.name == 'staffgl' || currentRoute.name == 'StudentStyle') {
                    router.push('/Manage')
              }else{
                router.push('/login')
              }

                // let sinintype = window.localStorage.getItem('sinintype')
                // if(sinintype == '管理') {
                //   router.push('/Manage')
                // }else if(sinintype == '学员'){
                //   router.push('/login')
                // }else if(response.data.data === 1) {
                //   router.push('/Manage')
                // }else if(response.data.data === 0) {
                //   router.push('/login')
                // }
            }).catch(() => {
              if(currentRoute.name == 'home' || currentRoute.name == 'course' || currentRoute.name == 'training' 
                || currentRoute.name == 'staffgl' || currentRoute.name == 'StudentStyle') {
                    router.push('/Manage')
              }else{
                router.push('/login')
              }
                //  let sinintype = window.localStorage.getItem('sinintype')
                // if(sinintype == '管理') {
                //   router.push('/Manage')
                // }else if(sinintype == '学员'){
                //   router.push('/login')
                // }else if(response.data.data === 1) {
                //   router.push('/Manage')
                // }else if(response.data.data === 0) {
                //   router.push('/login')
                // }
            })
        } else {
            Message.error({
                message: response.data.msg,
            });
        }
    }
    if (response && response.data && response.data.code === 205) {
      // 说明token失效,需要清空失效的token,然后跳转到登录页
      store.commit('user/removeToken')
      let sinintype = window.localStorage.getItem('sinintype')
      if(sinintype == '管理') {
        router.push('/Manage')
      }else if(sinintype == '学员'){
        router.push('/login')
      }
      
      // 提示信息
      Message({
       message: '登录信息失效,请重新登录', // message后端返回的错误信息
       type: 'error',
      })
     }
    return response;
}, function (error) {
    if (loadingInstance) {
        loadingInstance.close()
    }
    if (error.config ) {
       
            if (error.response.status) {
                let statusC =  error.response.status
                if (statusC == 500 || statusC == 501 || statusC == 502 || statusC == 503  || statusC == 504 || statusC == 401) {
                    Message.error({
                        message:'错误提示'+statusC,
                    });
                } 
            }
    
    }
    return Promise.reject(error.config);

});
Vue.config.productionTip = false
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js